import { render, staticRenderFns } from "./ListClaims.vue?vue&type=template&id=5eae120a&scoped=true"
import script from "./ListClaims.vue?vue&type=script&lang=js"
export * from "./ListClaims.vue?vue&type=script&lang=js"
import style0 from "./ListClaims.vue?vue&type=style&index=0&id=5eae120a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eae120a",
  null
  
)

export default component.exports